import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { catchError, tap } from 'rxjs/operators';
import { NotificationService } from '../notification.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private notification: NotificationService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {  
                // 401 handled in auth.interceptor
                if (error.status !== 401) {                                                            
                    this.notification.error(error.error.message
                         ? error.error.message : 'Encountered unknown error');                    
                }
                return throwError(error);
            }),
            tap((res: HttpResponse<any>) => {
                if (res.body && res.body.message) {
                  this.notification.success(res.body.message);
                }
            })
        );
    }
}
